/* eslint-disable */
import { defineStore } from 'pinia';
import { applyDrag, generateItems } from '../worker_order/services/helpers';
import moment from 'moment';
import apiOtsService from '@/worker_order/services/OtsService';
import apiOtsWarehouseService from '@/worker_order/services/OtsWarehouseService';
import RentalContractService from '@/rental_contracts/services/RentalContractService';
import {
  getStoredPermissions,
  getStoredRoleNames,
  hasStoredPermissionsPayload,
  isDefaultGrantedPermission,
  normalizePermissionNames,
  normalizeRoleNames,
} from '@/permissions/helpers';

const loadWarehouseService = async () => {
  const module = await import('@/warehouse/services/WarehouseService');
  return module.default || module;
};

let formOrderWork = {
  coupled_id: '',
  has_warehouse: true,
  applicant: '',
  id: '',
  signature_image: null,
  truck_id: '',
  applicant: '',
  responsible: '',
  kilometer: '',
  request: '',
  description_of_requeriment: '',
  path_image_signature: '',
  date_estimed: '',
  hour_estimed: '',
  place: '',
  type_of_maintenance: '',
  work_order_category_id: null,
  status: 'PENDING',
  codes: [],
  review_by: '',
  owner_user_id: '',
  applicant_driver_id: '',
  responsible_specialist_id: '',
  reviewed_by_specialist_id: '',
  delivered_to_driver_id: '',
  delivered_to: '',
  observation: '',
  works: [],
  deadline_at: '',
  defaultWork: {
    id: "",
    description: "",
    reviewed_by_specialist_id: "",
    hours: '',
    task: '',
    specialist: "",
    target_start_date: "",
    target_start_time: "",
    target_end_date: "",
    target_end_time: "",
    start_time: "",
    end_time: "",
    duration: "",
    duration_time: "",
    duration_hour: "",
  },
  editedIndexWork: -1,
  editedWork: {
    id: "",
    specialist: "",
    reviewed_by_specialist_id: "",
    description: "",
    hours: '',
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    target_start_date: "",
    target_start_time: "",
    target_end_date: "",
    target_end_time: "",
    priority: "",
    type_maintenance: "",
  },
  supplies: [],
  supplies_with_warehouse: [],
  defaulSupplies: {
    id: '',
    code: '',
    name: '',
    description: '',
    amount: '',
    cost: null,
  },
  editedIndexSupplies: -1,
  editedSupplies: {
    id: '',
    code: '',
    name: '',
    description: '',
    amount: '',
    cost: null,
  },
}

export const useAppStore = defineStore('app', {
  state: () => ({
    total: 0,
    neto: 0,
    iva: 0,
    loadingCatalogs: false,
    workOrderCatalogsWorkshopId: null,
    loadingOrderWork: false,
    select_calendar_from_date : false,
    currentTab: null,
    typesMaintenance: [],
    preview: false,
    loadingOts: false,
    groupsCalendar: [],
    selectedEventType: ['Ordenes de Trabajo'],
    events: [],
    worksCalendars: [],
    otsCalendars: [],
    specialistsWithoutFormat: [],
    selectedSpecialistCalendar: null,
    filtersCalendar: {
      start: '',
      end: '',
      specialist: [],
      planned : '',
      box_id: '',
    },
    ots: [],
    settings: null,
    feature_modules: [],
    feature_flags: {},
    feature_flags_loaded: false,
    preferences: null,
    preferences_user: [],
    codes: [],
    params: {
      page: 1,
      perPage: 5,
      search: '',
    },
    sideBarCreateAlertOpen: false,
    generalDrawer: false,
    generalDialog: false,
    loadingSupplies: false,
    drawer_service: false,
    drawer_filter: false,
    drawer_filter_content: '',
    serviceDocumentsDrawer: false,
    serviceDocumentsData: null,
    patents: [],
    originalObjectCreateWork: {},
    order_is_edited: false,
    drawer: false,
    sheet_create_modal: false,
    drawer_create_order: false,
    drawer_supplies: false,
    drawer_supplies_with_warehouse: false,
    trucks: [],
    users: [],
    specialists: [],
    drivers: [],
    locations: [],
    company: null,
    role: [],
    permissions: [],
    workshop: null,
    workshops: JSON.parse(localStorage.getItem('workshops') || '[]'),
    active_workshop: localStorage.getItem('active_workshop') || '',
    drawer_filter_history_order_work: false,
    filter_history_order_work: {
      from: '',
      to: '',
      truck: '',
      location: '',
      responsable: '',
      applicant: '', // "SOLICITANTE"
      specialists: '', // "ENCARGADO"
      review_by: '', // "REVISADO POR"
      delivered_to: '', // "ENTREGADO A"
      search: '',
      status: '',
      planned: '',
      sort_by: '',
    },
    error_form_work_order: {},
    ots_by_groups: {
      pending: [],
      in_revision: [],
      in_progress: [],
      finalized: [],
    },
    snackbar: {
      visible: false,
      text: '',
      icon: '',
      color: '',
      bottom: true,
      timeout: 4000,
      persistent: false,
      source: null,
    },
    coupled: [],
    counterFilterHistory: 0,
    supplies: [],
    currentWarehouse: null,
    error_supplies: [],
    formTask: {
      code: '',
      name: '',
    },
    form_create_work: {
      planned : false,
      box_id: null,
      coupled_id: '',
      rental_contract_id: null,
      rental_contract: null,
      has_warehouse: false,
      workshop_selected_supply: false,
      warehouse_id: '',
      workshop_id: '',
      applicant: '',
      id: '',
      img_signature_delivered: '',
      img_signature_reviewed: '',
      is_signature_delivered: false,
      is_signature_reviewed: false,
      truck_id: '',
      applicant: '',
      responsible: '',
      kilometer: '',
      request: '',
      description_of_requeriment: '',
      path_image_signature: '',
      date_estimed: '',
      hour_estimed: '',
      place: '',
      type_of_maintenance: '',
  work_order_category_id: null,
      status: 'PENDING',
codes: '',
      review_by: '',
      owner_user_id: '',
      applicant_driver_id: '',
      responsible_specialist_id: '',
      responsible_specialist_search: '',
      responsible_specialist_loading: false,
      reviewed_by_specialist_id: '',
      delivered_to_driver_id: '',
      delivered_to: '',
      observation: '',
      works: [],
      deadline_at: '',
      priority: "",
      type_maintenance_id: "",
      work_order_category_id: null,
      defaultWork: {
        id: "",
        description: "",
        reviewed_by_specialist_id: "",
        hours: '',
        task: '',
        specialist: "",
        target_start_date: "",
        target_start_time: "",
        target_end_date: "",
        target_end_time: "",
        start_time: "",
        end_time: "",
        duration: "",
        duration_time: "",
        duration_hour: "",
      },
      editedIndexWork: -1,
      editedWork: {
        id: "",
        specialist: "",
        reviewed_by_specialist_id: "",
        description: "",
        hours: '',
        task: '',
        target_start_date: "",
        target_start_time: "",
        target_end_date: "",
        target_end_time: "",
        start_time: "",
        end_time: "",
        duration: "",
        duration_time: "",
        duration_hours: "",
        priority: "",
        type_maintenance: "",
      },
      supplies: [],
      supplies_with_warehouse: [],
      defaulSupplies: {
        id: '',
        code: '',
        name: '',
        description: '',
        amount: '',
        cost: null,
      },
      editedIndexSupplies: -1,
      editedSupplies: {
        id: '',
        code: '',
        name: '',
        description: '',
        amount: '',
        cost: null,
      },
      workshop_entry_date: "",
      workshop_entry_time: "",
      workshop_departure_date: "",
      workshop_departure_time: "",
      services: [
      ]
    },
    from_filter: '',
    progress_loader: false,
    linear_progress_loader: false,
    currentForm: null,
    currentFormDialog: null,
    currentFormDialogData: null,
    warehouses: [],
    countTotalHistoryOrderWorks: 0,
    boxes: [],
    workOrderCategories: [],
    workOrderCatalogsError: '',
  }),
  mutations: {
    setDrawerSupplies(state, payload) {
      state.drawer_supplies = payload;
    },
  },
  actions: {
    async fetchTypesMaintenance() {
      try {
        const response = await apiOtsService.getTypesMaintenance();
        this.typesMaintenance = response.data;
      } catch (error) {
        this.typesMaintenance = [];
        console.log(error);
      }
    },
    setFeatureModules(modules) {
      this.feature_modules = modules || [];
      this.feature_flags = (modules || []).reduce((acc, module) => {
        acc[module.slug] = !!module.enabled;
        return acc;
      }, {});
      localStorage.setItem('feature_flags', JSON.stringify(this.feature_flags));
      this.feature_flags_loaded = true;
    },
    hasFeature(featureSlug) {
      if (!featureSlug) {
        return true;
      }

      if (Object.prototype.hasOwnProperty.call(this.feature_flags, featureSlug)) {
        return !!this.feature_flags[featureSlug];
      }

      return true;
    },
    setPermissions(permissions) {
      this.permissions = normalizePermissionNames(permissions);
      localStorage.setItem('permissions', JSON.stringify(this.permissions));
    },
    setSettings(settings) {
      this.settings = Array.isArray(settings) ? settings : [];
      localStorage.setItem('settings', JSON.stringify(this.settings));
      this.form_create_work.has_warehouse = this.getHasWarehouseSettingValue();
    },
    setRole(role) {
      this.role = normalizeRoleNames(role);
      localStorage.setItem('role', JSON.stringify(this.role));
    },
    getHasWarehouseSettingValue() {
      const settingsSource = Array.isArray(this.settings) && this.settings.length
        ? this.settings
        : JSON.parse(localStorage.getItem('settings') || '[]');
      const firstSetting = Array.isArray(settingsSource) && settingsSource.length
        ? settingsSource[0]
        : null;

      return firstSetting?.pivot?.setting_value === 1 || firstSetting?.pivot?.setting_value === true;
    },
    applySession(session = {}) {
      const {
        user = null,
        company = null,
        workshop = null,
        workshops = [],
        role = [],
        permissions = [],
      } = session;

      this.company = company;
      this.workshop = workshop;
      this.workshops = workshops;
      localStorage.setItem('workshops', JSON.stringify(workshops));

      const isValidActiveWorkshop = this.active_workshop === 'all'
        ? workshops.length > 1
        : workshops.some((item) => String(item.id) === String(this.active_workshop));
      if (this.active_workshop && !isValidActiveWorkshop) {
        this.active_workshop = '';
        localStorage.removeItem('active_workshop');
      }
      this.setRole(role);
      this.setPermissions(permissions);

      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('company', JSON.stringify(company));
      localStorage.setItem('workshop', JSON.stringify(workshop));
    },
    setActiveWorkshop(value) {
      if (value) {
        localStorage.setItem('active_workshop', String(value));
      } else {
        localStorage.removeItem('active_workshop');
      }
      // Recarga para que todas las vistas consulten con la nueva sucursal.
      window.location.reload();
    },
    isAllWorkshops() {
      return this.active_workshop === 'all';
    },
    clearSession() {
      this.company = null;
      this.workshop = null;
      this.workshops = [];
      this.active_workshop = '';
      this.role = [];
      this.permissions = [];
      this.settings = null;
      this.feature_modules = [];
      this.feature_flags = {};
      this.feature_flags_loaded = false;

      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('company');
      localStorage.removeItem('workshop');
      localStorage.removeItem('workshops');
      localStorage.removeItem('active_workshop');
      localStorage.removeItem('role');
      localStorage.removeItem('permissions');
      localStorage.removeItem('settings');
      localStorage.removeItem('feature_modules');
      localStorage.removeItem('feature_flags');
    },
    loadPermissionsFromStorage() {
      this.permissions = getStoredPermissions();
    },
    isSuperAdmin() {
      const currentRoleNames = normalizeRoleNames(this.role);

      if (currentRoleNames.length) {
        return currentRoleNames.includes('super-admin');
      }

      return getStoredRoleNames().includes('super-admin');
    },
    canSelectWorkshop() {
      const currentRoleNames = normalizeRoleNames(this.role)
        .map((roleName) => String(roleName).toLowerCase());

      if (currentRoleNames.length) {
        return currentRoleNames.includes('super-admin') || currentRoleNames.includes('admin');
      }

      return getStoredRoleNames()
        .map((roleName) => String(roleName).toLowerCase())
        .some((roleName) => roleName === 'super-admin' || roleName === 'admin');
    },
    hasPermission(permissionName) {
      if (!permissionName) {
        return true;
      }

      if (this.isSuperAdmin()) {
        return true;
      }

      if (isDefaultGrantedPermission(permissionName)) {
        return true;
      }

      if (!this.permissions.length && !hasStoredPermissionsPayload()) {
        return true;
      }

      return this.permissions.includes(permissionName);
    },
    hasAnyPermission(permissionNames = []) {
      if (!permissionNames.length) {
        return true;
      }

      if (this.isSuperAdmin()) {
        return true;
      }

      if (permissionNames.some((permissionName) => isDefaultGrantedPermission(permissionName))) {
        return true;
      }

      if (!this.permissions.length && !hasStoredPermissionsPayload()) {
        return true;
      }

      return permissionNames.some((permissionName) => this.permissions.includes(permissionName));
    },
    async handleSpecialists(params) {
      try {
        const response = await apiOtsService.getSpecialists(params);

        this.specialists = response.data.map((e) => {
          return {
            ...e,
            fullTextWithoutDni: e.dni + ' - ' + e.names + ' ' + e.last_name_p + ' ' + e.last_name_m,
          fullText:
            e.names +
            ' ' +
            e.last_name_p +
            ' ' +
            e.last_name_m +
            ' ' +
            e.dni +
            ' ' +
            (e.position?.name || ''),
        };
      });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      // handle the response data here
    },
    async getWarehousesByLocation(workshop) {
      try {
        const apiWarehouse = await loadWarehouseService();
        const response = await apiWarehouse.getWarehousesByLocation(workshop, {
          skipForbiddenRedirect: true,
        });
        this.warehouses = response.data;
      } catch (error) {
        this.warehouses = [];
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    async fetchWorkOrderCatalogs(params = {}) {
      this.loadingCatalogs = true;
      this.workOrderCatalogsError = '';
      try {
        const response = await apiOtsService.getWorkOrderCatalogs(params, {
          skipForbiddenRedirect: true,
        });
        const catalogs = response.data || {};

        this.trucks = catalogs.trucks || [];
        this.users = catalogs.users || [];
        this.coupled = catalogs.coupled || [];
        this.specialists = (catalogs.specialists || []).map((e) => ({
          ...e,
          fullTextWithoutDni: e.dni + ' - ' + e.names + ' ' + e.last_name_p + ' ' + e.last_name_m,
          fullText:
            e.names +
            ' ' +
            e.last_name_p +
            ' ' +
            e.last_name_m +
            ' ' +
            e.dni +
            ' ' +
            (e.position?.name || ''),
        }));
        this.drivers = (catalogs.drivers || []).map((e) => ({
          ...e,
          fullText: e.names + ' ' + e.last_name_p + ' ' + e.last_name_m + ' ' + e.dni,
        }));
        this.locations = catalogs.locations || [];
        this.warehouses = catalogs.warehouses || [];
        this.boxes = catalogs.boxes || [];
        this.typesMaintenance = catalogs.typesMaintenance || [];
        this.workOrderCategories = catalogs.workOrderCategories || [];
        this.workOrderCatalogsWorkshopId = params.workshop_id || null;
      } catch (error) {
        if (error?.response?.status === 403) {
          this.workOrderCatalogsError =
            'No tienes permiso para cargar algunos catálogos de esta orden de trabajo.';
        }
        this.trucks = [];
        this.users = [];
        this.coupled = [];
        this.specialists = [];
        this.drivers = [];
        this.locations = [];
        this.warehouses = [];
        this.boxes = [];
        this.typesMaintenance = [];
        this.workOrderCategories = [];
        // eslint-disable-next-line no-console
        console.log(error);
      } finally {
        this.loadingCatalogs = false;
      }
    },
    async fetchWorkOrderFilterCatalogs() {
      try {
        const response = await apiOtsService.getWorkOrderFilterCatalogs({
          skipForbiddenRedirect: true,
        });
        const catalogs = response.data || {};

        this.trucks = catalogs.trucks || [];
        this.specialists = (catalogs.specialists || []).map((e) => ({
          ...e,
          fullTextWithoutDni: e.dni + ' - ' + e.names + ' ' + e.last_name_p + ' ' + e.last_name_m,
          fullText:
            e.names +
            ' ' +
            e.last_name_p +
            ' ' +
            e.last_name_m +
            ' ' +
            e.dni +
            ' ' +
            (e.position?.name || ''),
        }));
        this.users = catalogs.users || [];
        this.drivers = (catalogs.drivers || []).map((e) => ({
          ...e,
          fullText: e.names + ' ' + e.last_name_p + ' ' + e.last_name_m + ' ' + e.dni,
        }));
        this.locations = catalogs.locations || [];
      } catch (error) {
        this.trucks = [];
        this.specialists = [];
        this.users = [];
        this.drivers = [];
        this.locations = [];
        console.log(error);
      }
    },
    async fetchTrucks() {
      try {
        const response = await apiOtsService.getTrucks();
        this.trucks = response.data;
      } catch (error) {
        this.trucks = [];
        console.log(error);
      }
    },
    async fetchRequest() {
      try {
        const response = await apiOtsService.getUsers();
        this.users = response.data;
      } catch (error) {
        this.users = [];
        console.log(error);
      }
    },
    async fetchLocations() {
      try {
        const response = await apiOtsService.getLocations();
        this.locations = response.data;
      } catch (error) {
        this.locations = [];
        console.log(error);
      }
    },
    async fetchSpecialists() {
      try {
        const response = await apiOtsService.getSpecialists();
        this.specialists = response.data.map((e) => {
          return {
            ...e,
            fullTextWithoutDni: e.dni + ' - ' + e.names + ' ' + e.last_name_p + ' ' + e.last_name_m,
            fullText:
              e.names +
              " " +
              e.last_name_p +
              " " +
              e.last_name_m +
              " " +
              e.dni +
              " " +
              (e.position?.name || ""),
          };
        });
      } catch (error) {
        this.specialists = [];
        console.log(error);
      }
    },
    async fetchCoupleds() {
      try {
        const response = await apiOtsService.getCoupled();
        this.coupled = response.data;
      } catch (error) {
        this.coupled = [];
        console.log(error);
      }
    },
    async fetchWarehouse() {
      if (!this.form_create_work.workshop_id) return;
      const apiWarehouse = await loadWarehouseService();
      const response = await apiWarehouse.getWarehousesByLocation(this.form_create_work.workshop_id);
      this.warehouses = response.data;
    },
    toogleGeneralDrawer(val, form, data = null) {
      this.generalDrawer = val;
      this.currentFormDialog = form;
      this.currentFormDialogData = data;
    },
    toogleGeneralDialog(val, form) {
      this.currentFormDialog = form;
      this.generalDialog = val;
    },
    toggleDrawerFilterRight(from) {
      this.drawer_filter = !this.drawer_filter;
      this.drawer_filter_content = null;
    },
    openServiceDocumentsDrawer(data) {
      this.serviceDocumentsData = data;
      this.serviceDocumentsDrawer = true;
    },
    closeServiceDocumentsDrawer() {
      this.serviceDocumentsDrawer = false;
      this.serviceDocumentsData = null;
    },
    updateServiceDocumentsCount(serviceId, count) {
      const services = this.form_create_work.services;
      if (!services) return;
      const idx = services.findIndex((s) => s.id === serviceId);
      if (idx !== -1) {
        services.splice(idx, 1, { ...services[idx], documents_count: count });
      }
    },
    defaultFormOrderWork() {
      return JSON.parse(
        JSON.stringify({
          ...formOrderWork,
        })
      );
    },
    async deleteWork(work_id) {
      await apiOtsService.deleteWork(work_id);
    },
    setInitialLocation(val) {
      this.filter_history_order_work.location = val;
    },
    toggleDrawerLeft() {
      this.drawer = !this.drawer;
    },
    openCreateOrderModal() {
      if (!this.canSelectWorkshop()) {
        const currentWorkshop = this.workshop || JSON.parse(localStorage.getItem('workshop') || 'null');

        if (currentWorkshop?.id) {
          this.form_create_work.workshop_id = currentWorkshop.id;
        }
      }

      this.form_create_work.has_warehouse = this.getHasWarehouseSettingValue();
      this.sheet_create_modal = true;
    },
    async toggleSheetCreateOrderWork() {
      if (!this.canSelectWorkshop()) {
        const currentWorkshop = this.workshop || JSON.parse(localStorage.getItem('workshop') || 'null');

        if (currentWorkshop?.id) {
          this.form_create_work.workshop_id = currentWorkshop.id;
        }
      }

      const nextValue = !this.sheet_create_modal;

      if (nextValue) {
        if (!this.form_create_work.id) {
          this.form_create_work.has_warehouse = this.getHasWarehouseSettingValue();
        }
        this.sheet_create_modal = true;

        const workshopId = this.form_create_work.workshop_id || null;
        const shouldRefreshCatalogs = !this.loadingCatalogs
          && (this.workOrderCatalogsWorkshopId === null || this.workOrderCatalogsWorkshopId !== workshopId);

        if (shouldRefreshCatalogs) {
          void this.fetchWorkOrderCatalogs({
            workshop_id: workshopId,
          });
        }
      } else {
        this.drawer_supplies = false;
        this.drawer_supplies_with_warehouse = false;
        this.drawer_service = false;
        this.currentWarehouse = null;
        this.sheet_create_modal = false;
      }

      this.currentWarehouse = null;
    },
    toggleDrawerCreateOrderWork() {
      if (!this.drawer_create_order && this.form_create_work.editedIndexWork === -1) {
        const now = moment();
        this.form_create_work.editedWork.target_start_date = now.format('YYYY-MM-DD');
        this.form_create_work.editedWork.target_start_time = now.format('HH:mm');
      }

      this.drawer_create_order = !this.drawer_create_order;
    },
    toggleDrawerCreateOrderSupplies() {
      if (!this.form_create_work.id) {
        this.form_create_work.has_warehouse = this.getHasWarehouseSettingValue();
      }

      if (this.form_create_work.has_warehouse) {
        this.drawer_supplies = false;
        this.drawer_supplies_with_warehouse = !this.drawer_supplies_with_warehouse;
      } else {
        this.drawer_supplies_with_warehouse = false;
        this.drawer_supplies = !this.drawer_supplies;
      }
    },
    shouldUseWarehouseFlow() {
      return !!this.form_create_work.has_warehouse;
    },
    toogleDrawerService(val) {
      this.drawer_service = !this.drawer_service;
    },
    toggleDrawerFilterHistoryOrderWork(from) {
      this.from_filter = from;
      this.drawer_filter_history_order_work = !this.drawer_filter_history_order_work;
    },
    openSnackbar(text, options = {}) {
      const snackbarOptions = typeof options === 'string' ? { color: options } : options;

      this.snackbar = {
        visible: true,
        text,
        icon: snackbarOptions.icon || '',
        color: snackbarOptions.color || '',
        bottom: snackbarOptions.bottom ?? true,
        timeout: snackbarOptions.timeout ?? 4000,
        persistent: snackbarOptions.persistent ?? false,
        source: snackbarOptions.source || null,
      };
    },
    async handleDrivers() {
      try {
        const response = await apiOtsService.getDrivers();
        this.drivers = response.data.map((e) => {
          return {
            ...e,
            fullText: e.names + ' ' + e.last_name_p + ' ' + e.last_name_m + ' ' + e.dni,
          };
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    countAttributesWithValues() {
      let count = 0;
      for (let key in this.filter_history_order_work) {
        if (!this.filter_history_order_work.hasOwnProperty(key)) {
          continue;
        }

        if (!this.canSelectWorkshop() && key === 'location') {
          continue;
        }

        const value = this.filter_history_order_work[key];
        if (value === '' || value === null || value === undefined) {
          continue;
        }

        if (Array.isArray(value) && value.length === 0) {
          continue;
        }

        count++;
      }
      this.counterFilterHistory = count;
    },
    resetFilterHistoryOts() {

      this.filter_history_order_work = {
        from: '',
        to: '',
        truck: '',
        location: '',
        responsable: '',
        applicant: '', // "SOLICITANTE"
        specialists: '', // "ENCARGADO"
        review_by: '', // "REVISADO POR"
        delivered_to: '', // "ENTREGADO A"
        search: '',
        planned: '',
      }

      this.countAttributesWithValues();
    },
    resetForm() {
      this.form_create_work = {
        planned : false,
        services: [],
        coupled_id: '',
        rental_contract_id: null,
        rental_contract: null,
        workshop_id: '',
        has_warehouse: this.getHasWarehouseSettingValue(),
        workshop_selected_supply: false,
        applicant: '',
        id: '',
        signature_image: null,
        truck_id: '',
        applicant: '',
        responsible: '',
        kilometer: '',
        request: '',
        description_of_requeriment: '',
        path_image_signature: '',
        date_estimed: '',
        hour_estimed: '',
        place: '',
        type_of_maintenance: '',
  work_order_category_id: null,
        status: 'PENDING',
codes: '',
        review_by: '',
        owner_user_id: '',
        applicant_driver_id: '',
        responsible_specialist_id: '',
        reviewed_by_specialist_id: '',
        delivered_to_driver_id: '',
        delivered_to: '',
        observation: '',
        works: [],
        deadline_at: '',
        defaultWork: {
          id: "",
          description: "",
          reviewed_by_specialist_id: "",
          hours: '',
          task: '',
          specialist: "",
          target_start_date: "",
          target_start_time: "",
          target_end_date: "",
          target_end_time: "",
          start_time: "",
          end_time: "",
          duration: "",
          duration_time: "",
          duration_hour: "",
        },
        editedIndexWork: -1,
        editedWork: {
          id: "",
          description: "",
          reviewed_by_specialist_id: "",
          hours: '',
          task: '',
          specialist: "",
          target_start_date: "",
          target_start_time: "",
          target_end_date: "",
          target_end_time: "",
          start_time: "",
          end_time: "",
          duration: "",
          duration_time: "",
          duration_hour: "",
          priority: "",
          type_maintenance: "",
        },
        supplies: [],
        supplies_with_warehouse: [],
        order_supplies : [],
        defaulSupplies: {
          id: '',
          code: '',
          name: '',
          description: '',
          amount: '',
          cost: null,
        },
        editedIndexSupplies: -1,
        editedSupplies: {
          id: '',
          code: '',
          name: '',
          description: '',
          amount: '',
          cost: null,
        },
        img_signature_delivered: '',
        img_signature_reviewed: '',
        is_signature_delivered: false,
        is_signature_reviewed: false,
        workshop_entry_date: '',
        workshop_entry_time: '',
        workshop_departure_date: '',
        workshop_departure_time: '',
      };
      this.currentWarehouse = null;
      this.drawer_supplies = false;
      this.drawer_supplies_with_warehouse = false;
      this.drawer_service = false;
    },
    async handleShowOrderWork(id) {
      this.order_is_edited = true;

      let response = null;

      try {
        if (this.form_create_work.has_warehouse) {
          response = await apiOtsWarehouseService.getOtsById(id);
        } else {
          response = await apiOtsService.getOtsById(id);
        }


        this.form_create_work.has_warehouse = response.data.has_warehouse;

        this.form_create_work = { ...this.form_create_work, ...response.data };
        await this.loadRentalContractForForm(response.data);

        if (response.data.work_order_category_id) {
          this.form_create_work.work_order_category_id = response.data.work_order_category_id;
        } else if (response.data.work_order_category && response.data.work_order_category.id) {
          this.form_create_work.work_order_category_id = response.data.work_order_category.id;
        } else {
          this.form_create_work.work_order_category_id = null;
        }

        this.form_create_work.works = response.data.combinedWorks;

        this.form_create_work.services = response.data.work_order_service.map((el) => ({
          ...el,
          ...el.provider,
          provider_id: el.service.provider.id,
          provider_name: el.service.provider.name,
          code: el.service.code,
          name: el.service.name,
          description: el.service.description,
          category: el.service.category,
          bill: el.invoice,
          count: el.count,
          total_price: el.total_price,
          cost_responsible: el.cost_responsible || 'company',
        }));

        this.form_create_work.has_warehouse = this.form_create_work.has_warehouse === 1 ? true : false

        this.form_create_work.works = response.data.combinedWorks.map((el) => {

          let start = moment(el.start_time);
          let end = moment(el.end_time);
          let duration = null;
          let target_hours = null;
          let minutes = null;
          let target_duration = null;

          if (el.hours && !el.start_time && !el.end_time) {

            duration = moment.duration(el.hours, 'hours');
            target_hours = Math.floor(duration.asHours());
            minutes = Math.floor(duration.minutes());
            target_duration = `${target_hours} hours ${minutes} minutes`;

          }

          if (el.start_time && !el.end_time) {
            target_duration = null;
          }

          if (el.start_time && el.end_time) {
            duration = moment.duration(end.diff(start));
            target_hours = Math.floor(duration.asHours());
            minutes = Math.floor(duration.minutes());
            target_duration = `${target_hours} hours ${minutes} minutes`;

          }

          return {
            ...el,
            target_start_date: el.start_time ? moment(el.start_time).format('YYYY-MM-DD') : '',
            target_start_time: el.start_time ? moment(el.start_time).format('HH:mm') : '',
            target_end_date: el.end_time ? moment(el.end_time).format('YYYY-MM-DD') : '',
            target_end_time: el.end_time ? moment(el.end_time).format('HH:mm') : '',
            start_time: el.start_time ? moment(el.start_time) : null,
            end_time: el.end_time ? moment(el.end_time) : null,
            duration: target_duration,
          }
        });

        if (this.form_create_work.has_warehouse) {
          this.form_create_work.supplies_with_warehouse = response.data.order_supplies.map(el => ({
            ...el,
            new_count: el.count
          }));
        } else {
          this.form_create_work.supplies = response.data.order_supplies;
        }


        this.supplies = this.form_create_work.supplies
          ? this.supplies.map((el) => {
            let index = this.form_create_work.supplies.find(
              (item) => item.supply_id == el.id
            );
            return { ...el, aggregate: index ? true : false };
          })
          : [];

        this.getWarehousesByLocation(this.form_create_work.workshop_id);

        this.handleSpecialists({ 'workshop': this.form_create_work.workshop_id });

      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    async loadRentalContractForForm(workOrder) {
      this.form_create_work.rental_contract =
        workOrder.rental_contract || workOrder.rentalContract || null;

      if (workOrder.rental_contract_id && !this.form_create_work.rental_contract) {
        try {
          const contractResponse = await RentalContractService.getContract(
            workOrder.rental_contract_id,
            { skipForbiddenRedirect: true },
          );
          this.form_create_work.rental_contract = contractResponse.data;
        } catch (error) {
          this.form_create_work.rental_contract = null;
        }
      }
    },
    async fetchOtsCalendars(filters) {
      this.loadingOts = true;
      const response = await apiOtsService.getAllOtsCalendar(filters);

      let targetSpecialistFilter = this.filtersCalendar.specialist.map((specialist_id)=>{
        let responsible = this.specialists.find(el => el.id === specialist_id);
        return  responsible.names+' '+responsible.last_name_p+' '+responsible.last_name_m;
      })

      this.otsCalendars = response.data.map((el) => {


        let targetNameCategory = el.responsible ?  el.responsible.names+' '+el.responsible.last_name_p+' '+el.responsible.last_name_m : null;

        return {
          id: el.id,
          name: `#${el.id} - ${el.description_of_requeriment}`,
          start: el.workshop_entry_date && el.workshop_entry_time
            ? moment(`${el.workshop_entry_date} ${el.workshop_entry_time}`).format('YYYY-MM-DD HH:mm')
            : null,
          end: el.date_estimed && el.hour_estimed
            ? moment(`${el.date_estimed} ${el.hour_estimed}`).format('YYYY-MM-DD HH:mm')
            : null,
          start_format: el.workshop_entry_date && el.workshop_entry_time
            ? moment(`${el.workshop_entry_date} ${el.workshop_entry_time}`).format('HH:mm')
            : null,
          end_format: el.date_estimed && el.hour_estimed
            ? moment(`${el.date_estimed} ${el.hour_estimed}`).format('HH:mm')
            : null,
          type: 'ots',
          truck: `${el.truck.code} / ${el.truck.patent}`,
          category: targetSpecialistFilter.find(el => el === targetNameCategory),
          box :  el.box ? el.box.name : '',
          specialist: el.responsable ? el.responsible.names + ' ' + el.responsible.last_name_p + ' ' + el.responsible.last_name_m : null,
          planned: el.planned ? 'Planificada' : '',
          color : el.planned ? 'green lighten-1' : 'orange',
        };

      })

      if (this.selectedEventType.includes('Ordenes de Trabajo')) {
        this.events = this.otsCalendars;
      }
      if (this.selectedEventType.includes('Ordenes de Trabajo') && this.selectedEventType.includes('Trabajos')) {
        this.events = [...this.otsCalendars, ...this.worksCalendars];
      }
      this.loadingOts = false;
    },

    async fetchWorksCalendars(filters) {
      this.loadingOts = true;
      const response = await apiOtsService.getAllWorksCalendar(filters);

      let targetSpecialistFilter = this.filtersCalendar.specialist.map((specialist_id)=>{
        let specialist = this.specialists.find(el => el.id === specialist_id);
        return  specialist.names+' '+specialist.last_name_p+' '+specialist.last_name_m;
      })

      let works = response.data.map((el) => {
        if (el && el.start_time && el.specialist) {

          let task = el.task != null ? el.task.name : '';

          let targetNameCategory = el.specialist.names+' '+el.specialist.last_name_p+' '+el.specialist.last_name_m;

          return {
            id: el.id,
            ot: `N° OT - ${el.work_order_id}`,
            name: `${el.id} - ${task}`,
            start: el.start_time ? moment(el.start_time).format('YYYY-MM-DD HH:mm') : null,
            end: el.end_time ? moment(el.end_time).format('YYYY-MM-DD HH:mm') : null,
            specialist: el.specialist.names + ' ' + el.specialist.last_name_p + ' ' + el.specialist.last_name_m,
            start_time: el.start_time ? moment(el.start_time).format('HH:mm') : null,
            end_time: el.end_time ? moment(el.end_time).format('HH:mm') : null,
            color: 'blue',
            category: targetSpecialistFilter.find(el => el === targetNameCategory),
            type: 'works',
          }
        }
      }).filter(el => el !== undefined);

      this.worksCalendars = works;

      if (this.selectedEventType.includes('Trabajos')) {
        this.events = this.worksCalendars;
      }

      if (this.selectedEventType.includes('Ordenes de Trabajo') && this.selectedEventType.includes('Trabajos')) {
        this.events = [...this.otsCalendars, ...this.worksCalendars];
      }
      this.loadingOts = false;
    },
    async fetchBoxes() {
      try {
        const response = await apiOtsService.getBoxes();
        this.boxes = response.data;
      } catch (error) {
        this.boxes = [];
        console.log(error);
      }
    },
    createFakeFormOrderWork() {
      this.form_create_work = {
        planned : false,
        has_warehouse: true,
        workshop_selected_supply: false,
        warehouse_id: '',
        workshop_id: 6,
        applicant: '',
        id: '',
        signature_image: null,
        codes: '26',
        truck_id: 207,
        responsible: '',
        kilometer: '4334',
        request: '',
        description_of_requeriment: 'test',
        path_image_signature: '',
        date_estimed: '2023-09-28',
        hour_estimed: '03:04',
        place: 'WORKSHOP',
        type_of_maintenance: 'PREVENTIVE',
        work_order_category_id: null,
        status: 'PENDING',
        review_by: '',
        owner_user_id: '',
        applicant_driver_id: 441,
        responsible_specialist_id: 21,
        reviewed_by_specialist_id: '',
        delivered_to_driver_id: '',
        delivered_to: '',
        observation: '',
        works: [],
        deadline_at: '',
        has_warehouse: true,
        defaultWork: {
          id: "",
          description: "",
          reviewed_by_specialist_id: "",
          hours: '',
          task: '',
          specialist: "",
          target_start_date: "",
          target_start_time: "",
          target_end_date: "",
          target_end_time: "",
          start_time: "",
          end_time: "",
          duration: "",
          duration_time: "",
          duration_hour: "",
        },
        editedIndexWork: -1,
        editedWork: {
          id: "",
          description: "",
          reviewed_by_specialist_id: "",
          hours: '',
          task: '',
          specialist: "",
          target_start_date: "",
          target_start_time: "",
          target_end_date: "",
          target_end_time: "",
          start_time: "",
          end_time: "",
          duration: "",
          duration_time: "",
          duration_hour: "",
          priority: "",
          type_maintenance: "",
        },
        supplies: [],
        supplies_with_warehouse: [],
        defaulSupplies: {
          id: '',
          code: '',
          name: '',
          description: '',
          amount: '',
          cost: null,
        },
        editedIndexSupplies: -1,
        editedSupplies: {
          id: '',
          code: '',
          name: '',
          description: '',
          amount: '',
          cost: null,
        },
        coupled_id: 44,
        workshop_entry_date: '',
        workshop_entry_time: '',
        workshop_departure_date: '',
        workshop_departure_time: '',
      };
    },
  },
});
